/* R&B header v4: sticky behaviour (same classes as the theme's own sticky header, so the product page's
   floating back link keeps working), desktop panels, full-screen mobile menu. Calm motion, see rb-header.css. */
(function () {
  /* Focus box on MENU / BAG only for keyboard users (Carl 6 Oct): when a drawer or the bag closes, focus goes back to
     its button, and after a tap Safari drew a box around it. html.rb-kbd = the visitor is using the keyboard. */
  var de = document.documentElement;
  document.addEventListener('keydown', function (e) {
    if (/^(Tab|Enter| |Escape|Arrow)/.test(e.key) && !de.classList.contains('rb-kbd')) de.classList.add('rb-kbd');
  }, true);
  document.addEventListener('pointerdown', function () { if (de.classList.contains('rb-kbd')) de.classList.remove('rb-kbd'); }, true);

  var RbHeader = window.RbHeader = {
    openTimer: null, closeTimer: null,
    root: function () { return document.querySelector('[data-rb-header]'); },
    closePanels: function (focusBack) {
      var root = RbHeader.root(); if (!root) return;
      root.querySelectorAll('[data-rb-panel][aria-expanded="true"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        if (focusBack) b.focus();
      });
      root.querySelectorAll('.rbh__panel.is-open').forEach(function (p) { p.classList.remove('is-open'); setTimeout(function () { if (!p.classList.contains('is-open')) p.hidden = true; }, 340); });
      var veil = root.querySelector('[data-rb-veil]');
      if (veil) { veil.classList.remove('is-open'); setTimeout(function () { if (!veil.classList.contains('is-open')) veil.hidden = true; }, 340); }
      root.classList.remove('is-open');
      document.body.classList.remove('rbh-panel-open');
      var sh = root.closest('.section-header'); if (sh) sh.classList.remove('menu-open');
    },
    wake: function (panel) {
      if (!panel) return;
      panel.querySelectorAll('img[data-rb-src]').forEach(function (img) {
        if (img.dataset.rbSrcset) img.setAttribute('srcset', img.dataset.rbSrcset);
        img.setAttribute('src', img.dataset.rbSrc);
        img.removeAttribute('data-rb-src'); img.removeAttribute('data-rb-srcset');
      });
    },
    openPanel: function (btn) {
      var root = RbHeader.root(); if (!root) return;
      var id = btn.getAttribute('data-rb-panel');
      var panel = root.querySelector('[data-rb-panel-body="' + id + '"]');
      if (!panel) return;
      RbHeader.wake(panel);
      root.querySelectorAll('[data-rb-panel]').forEach(function (b) { if (b !== btn) b.setAttribute('aria-expanded', 'false'); });
      root.querySelectorAll('.rbh__panel.is-open').forEach(function (p) { if (p !== panel) { p.classList.remove('is-open'); p.hidden = true; } });
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      var veil = root.querySelector('[data-rb-veil]');
      if (veil) { veil.hidden = false; requestAnimationFrame(function () { veil.classList.add('is-open'); }); }
      root.classList.add('is-open');
      document.body.classList.add('rbh-panel-open');
      var sh = root.closest('.section-header'); if (sh) sh.classList.add('menu-open');
    }
  };

  if (!customElements.get('rb-sticky-header')) {
    class RbStickyHeader extends HTMLElement {
      connectedCallback() {
        this.header = this.closest('.section-header') || document.querySelector('.section-header');
        if (!this.header) return;
        this.always = this.getAttribute('data-sticky-type') === 'always';
        this.current = 0;
        this.setHeight();
        window.addEventListener('resize', this.setHeight.bind(this), { passive: true });
        if (this.always) this.header.classList.add('shopify-section-header-sticky');
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
      disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); }
      /* where the header sits in the page (above it: the announcement bar). A sticky element's offsetTop moves
         with the scroll, so it can't be used for "have we scrolled past the header?". */
      naturalTop() {
        var top = 0, el = this.header.previousElementSibling;
        while (el) { if (el.offsetParent !== null) top += el.offsetHeight; el = el.previousElementSibling; }
        return top;
      }
      setHeight() {
        this.top = this.naturalTop();
        var bar = this.querySelector('.rbh__bar');
        document.documentElement.style.setProperty('--header-height', ((bar ? bar.offsetHeight : this.header.offsetHeight)) + 'px');
      }
      onScroll() {
        var y = window.pageYOffset || document.documentElement.scrollTop;
        var limit = this.top + 40;
        if (document.body.classList.contains('rbh-drawer-open')) return;
        /* ignore tiny moves (trackpad / momentum jitter) so the header doesn't flicker */
        if (Math.abs(y - this.current) < 8 && y > limit) return;
        if (y > limit) {
          this.header.classList.add('scrolled-past-header');
          if (!this.always) {
            if (y > this.current) { this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); RbHeader.closePanels(); }
            else if (y < this.current) { this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
          }
        } else if (y <= this.top + 1) {
          this.header.classList.remove('scrolled-past-header');
          if (!this.always) this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }
        this.current = y;
      }
    }
    customElements.define('rb-sticky-header', RbStickyHeader);
  }

  function init() {
    var root = RbHeader.root(); if (!root || root.dataset.rbInit) return;
    root.dataset.rbInit = '1';
    if (window.Shopify && Shopify.designMode) root.querySelectorAll('.rbh__panel').forEach(RbHeader.wake);

    root.querySelectorAll('[data-rb-panel]').forEach(function (btn) {
      /* Warm the panel's pictures when the pointer or focus reaches the button, so they are there on click */
      var warm = function () { RbHeader.wake(root.querySelector('[data-rb-panel-body="' + btn.getAttribute('data-rb-panel') + '"]')); };
      btn.addEventListener('pointerenter', warm, { once: true });
      btn.addEventListener('focus', warm, { once: true });
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-expanded') === 'true') RbHeader.closePanels(); else RbHeader.openPanel(btn);
      });
    });
    /* Carl 4 Oct: Shop and Services open on click only, like every other link (no hover auto-open).
       Closes on a second click, Esc, the veil or a click outside the header. */
    var veil = root.querySelector('[data-rb-veil]');
    if (veil) veil.addEventListener('click', function () { RbHeader.closePanels(); });

    /* mobile menu: lives at the end of the page so nothing (announcement bar, pop-ups) sits on top of it */
    var drawers = document.querySelectorAll('[data-rb-drawer]');
    drawers.forEach(function (d) { if (d.dataset.rbMoved && drawers.length > 1) d.remove(); });
    var drawer = document.querySelector('[data-rb-drawer]:not([data-rb-moved])') || document.querySelector('[data-rb-drawer]');
    if (drawer && drawer.parentNode !== document.body) { drawer.dataset.rbMoved = '1'; document.body.appendChild(drawer); }
    var openBtn = root.querySelector('[data-rb-drawer-open]');
    // Focus is moved for keyboard users only: after a tap, iOS Safari drew a focus box around MENU (e.g. after
    // Search, which closes the menu, was closed again; Carl 6 Oct)
    var viaKeys = false;
    document.addEventListener('keydown', function () { viaKeys = true; }, true);
    document.addEventListener('pointerdown', function () { viaKeys = false; }, true);
    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.body.classList.add('overflow-hidden', 'rbh-drawer-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      var c = drawer.querySelector('[data-rb-drawer-close]'); if (c && viaKeys) setTimeout(function () { c.focus(); }, 60);
    }
    function closeDrawer() {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden', 'rbh-drawer-open');
      if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); if (viaKeys) openBtn.focus({ preventScroll: true }); else if (document.activeElement && drawer.contains(document.activeElement)) document.activeElement.blur(); }
      setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 340);
    }
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (drawer) {
      drawer.querySelectorAll('[data-rb-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
      var accs = drawer.querySelectorAll('[data-rb-acc]');
      accs.forEach(function (b, i) {
        var body = document.getElementById(b.getAttribute('aria-controls'));
        function set(open) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); if (body) body.classList.toggle('is-open', open); }
        if (i === 0) set(true); /* the first one (Shop) starts open */
        b.addEventListener('click', function () { set(b.getAttribute('aria-expanded') !== 'true'); });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawer && drawer.classList.contains('is-open')) { closeDrawer(); return; }
      if (root.querySelector('.rbh__panel.is-open')) RbHeader.closePanels(true);
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) RbHeader.closePanels();
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches) closeDrawer(); else RbHeader.closePanels(); });
  }

  /* Start page intro: once per 30 days (per browser) the large wordmark sits over the first section, then glides into the header.
     Starts when the loader is done; any scroll, tap or key skips it. */
  function intro() {
    var html = document.documentElement, el = document.querySelector('[data-rb-intro]');
    if (!el) return;
    if (!html.classList.contains('rb-intro')) { el.remove(); return; }
    try { localStorage.setItem('rbIntroSeen', String(Date.now())); } catch (e) {}
    document.body.appendChild(el);
    var target = document.querySelector('[data-rb-header] .rbh__wm svg');
    var timers = [], done = false, ease = 'cubic-bezier(.65,0,.35,1)';
    html.style.overflow = 'hidden';
    function finish() {
      if (done) return; done = true;
      timers.forEach(clearTimeout);
      ['wheel', 'touchstart', 'keydown'].forEach(function (t) { window.removeEventListener(t, finish); });
      var wm = target && target.parentNode;
      if (wm) wm.style.transition = 'none';
      html.classList.remove('rb-intro');
      html.style.overflow = '';
      el.remove();
      if (wm) { void wm.offsetWidth; requestAnimationFrame(function () { wm.style.transition = ''; }); }
    }
    ['wheel', 'touchstart', 'keydown'].forEach(function (t) { window.addEventListener(t, finish, { passive: true }); });
    var wait = Math.max(0, (window.RbLoaderUntil || 0) - Date.now()) + 150;
    timers.push(setTimeout(function () { el.classList.add('is-big'); }, wait));
    timers.push(setTimeout(function () {
      if (!target) { finish(); return; }
      var t = target.getBoundingClientRect(), r = el.getBoundingClientRect();
      var s = t.width / r.width, dx = (t.left + t.width / 2) - (r.left + r.width / 2), dy = (t.top + t.height / 2) - (r.top + r.height / 2);
      el.style.transition = 'transform 1s ' + ease;
      el.style.transform = 'translate(-50%, -50%) translate(' + dx + 'px, ' + dy + 'px) scale(' + s + ')';
    }, wait + 1600));
    timers.push(setTimeout(finish, wait + 2650));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); intro(); }); else { init(); intro(); }
  document.addEventListener('shopify:section:load', function () { var r = RbHeader.root(); if (r) delete r.dataset.rbInit; init(); });
})();
